import { render, staticRenderFns } from "./OrderRejectModal.vue?vue&type=template&id=d17031d0&scoped=true"
import script from "./OrderRejectModal.vue?vue&type=script&lang=js"
export * from "./OrderRejectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17031d0",
  null
  
)

export default component.exports